import { useCallback, useContext } from 'react';
import { UserTrackerContext } from './UserTrackerContext';
export function useTracker() {
    const instance = useContext(UserTrackerContext);
    const trackEvent = useCallback((params) => instance?.trackEvent(params), [instance]);
    return {
        trackEvent,
    };
}
